import { HotelImage } from './HotelImage';

export default HotelImage;
